<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="6">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field source="mws_configuration_id" ></va-field>
              <va-field source="status" ></va-field>
              <va-field source="revenue" ></va-field>
              <va-field source="fba_fee" ></va-field>
              <va-field source="product_cog" ></va-field>
              <va-field source="refund" ></va-field>
              <va-field source="advertising_cost" ></va-field>
              <va-field source="other_cost" ></va-field>
              <va-field source="net_profit" ></va-field>
              <va-field source="created_at" ></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
